export default function shortenurl(md) {
    const originalLinkOpenRenderer = md.renderer.rules.link_open;

    md.renderer.rules.link_open = (tokens, idx, options, env) => {
        const token = tokens[idx+1];

        if(token.type === 'text') {
            let content = token.content;
            // remove scheme https://
            content = content.replace(/^\w+:\/\//g, '');
            // remove everything between first / and last /
            content = content.replace(/\/(.)+\//g, '/…/');
            // remove everything after #
            content = content.replace(/\?(.)+/g, '?…');

            tokens[idx+1].content = content;
        }
        return originalLinkOpenRenderer(tokens, idx, options, env);
    };
}
